<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Upload Document</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar ref="sidebarScrollArea" class="vs-con-loading__container scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="pl-6 pr-6 pb-6">
        <div class="mb-3">
          <label>Document Type</label>
          <v-select ref="documentTypeDropdown" class="w-full style-chooser" placeholder="Search / Select a Document Type" :options="documentTypes" v-model="documentTypeDropdown" @search:blur="checkIfLinkedToModule"></v-select>
        </div>

        <div v-show="documentTypeDropdown && documentTypeDropdown.isLinkedToModule">
          <div class="mb-3">
            <label>Linked Module</label>
            <v-select ref="moduleDropdown" class="w-full style-chooser" placeholder="Search / Select Module" :options="modules" v-model="moduleDropdown"></v-select>
          </div>
        </div>

        <file-pond
          id="filepond"
          ref="pond"
          :server="uploadLocation"
          label-idle="Drop document here or <span class='filepond--label-action'>Browse</span>"
          :allow-multiple="false"
          :instant-upload="true"
          allowPaste=false
          :allow-image-preview="true"
          @processfile="uploadComplete"
          @removefile="fileRemoved"
        />
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="saveData" :disabled="isDisabled" ref="addupdateButton">Save</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select'

import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    studentId: {
      required: false
    },
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    FilePond
  },
  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        documentTypeId: null,
        moduleId: null,
        uploadedFileName: ""
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      documentTypes: [],
      documentTypeDropdown: 0,
      uploadedFileUrl: null,
      moduleDropdown: 0,
      modules: []
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    isDisabled: function(){
     return !this.formData.uploadedFileName;
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        this.getDocumentTypes();
      }
      this.initValues();
    }
  },
  methods: {
    initValues() {
      this.formData.documentTypeId = null;
      this.formData.moduleId = null;
      this.formData.uploadedFileName = "";
      this.documentTypeDropdown = 0;
      this.moduleDropdown = 0;
      this.$refs.pond.removeFiles();
      this.errors.clear();
    },
    getDocumentTypes() {
      var self = this;
      self.showLoadingOnElement("sidebarScrollArea", 1, "corners");

      var onSuccess = response => {
        self.documentTypes = response.data.map((item) => {return {label: item.name, value: item.id, isLinkedToModule: item.isLinkedToModule} });
      };
      var onFinally = function (){
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
      };
      
      self.$ajaxGet(self, "DocumentType/ListDocumentTypes", onSuccess, onFinally);
    },
    checkIfLinkedToModule() {
      var self = this;
      if(self.documentTypeDropdown) {
        if(self.documentTypeDropdown.isLinkedToModule) {
          self.getModules();
        }
      }
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.uploadedFileName = response.url;
    },
    fileRemoved(error, file) {
      this.formData.uploadedFileName = "";
    },
    saveData(){
      var self = this;

      if(self.documentTypeDropdown) {
        self.formData.documentTypeId = self.documentTypeDropdown ? parseInt(self.documentTypeDropdown.value) : null;
      }
      if(self.moduleDropdown) {
        self.formData.moduleId = self.moduleDropdown ? parseInt(self.moduleDropdown.value) : null;
      }

      self.$emit('saveData', self.formData);
    },
    getModules() {
      var self = this;
      self.showLoadingOnElement("sidebarScrollArea", 1, "corners");

      var onSuccess = response => {
        self.modules = []
        self.moduleDropdown = 0;
        self.modules = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      var onFinally = function (){
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
      };

      self.$ajaxGet(self, "StudentModule/GetStudentModulesSelectList?studentId=" + self.studentId, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    }
  },
  mounted() {
    var self = this;
    
  }
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
